import type { SchemaViewerFieldProps } from "./schema-viewer-field.type";

import { SchemaViewerFieldLabel } from "../schema-viewer-field-label";
import { SchemaViewerFormItem } from "../schema-viewer-form-item";

import { SchemaViewerField } from "./schema-viewer-field.component";

export const SchemaViewerFieldWrapper = ({
  schema,
  form,
  disabled,
}: SchemaViewerFieldProps) => {
  // Do not add `FormItem` for `label` field
  if (schema.type === "label") {
    return <SchemaViewerFieldLabel schema={schema} />;
  }

  return (
    <SchemaViewerFormItem schema={schema}>
      <SchemaViewerField schema={schema} form={form} disabled={disabled} />
    </SchemaViewerFormItem>
  );
};
